import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../web/components-v2/Theme/theme';

const { colors } = THEME;

export const styleSheet = StyleSheet.create({
	buttonRow: {
		display: 'flex',
		gap: 12,
		justifyContent: 'flex-end',
		marginTop: 24,
	},
	checkboxGrid: {
		display: 'grid',
		gap: 12,
		gridTemplateColumns: 'repeat(2, 1fr)',
		marginTop: 16,
	},
	checkboxLabel: {
		alignItems: 'center',
		color: colors.text.main,
		cursor: 'pointer',
		display: 'flex',
		fontSize: 14,
		gap: 8,
	},
	container: {
		maxHeight: '80vh',
		maxWidth: 700,
		overflowY: 'auto',
		padding: 24,
	},
	downloadButton: {
		':hover': {
			background: colors.background.light,
		},
		background: colors.background.light,
		border: `1px solid ${colors.border.main}`,
		borderRadius: 6,
		color: colors.text.main,
		padding: '10px 20px',
		textDecoration: 'none',
		transition: 'background 0.2s',
	},
	downloadButtons: {
		display: 'flex',
		gap: 12,
		justifyContent: 'center',
		marginTop: 16,
	},
	fileName: {
		color: colors.text.main,
		fontSize: 14,
		marginTop: 8,
		textAlign: 'center',
	},
	formGroup: {
		display: 'flex',
		flexDirection: 'column',
		marginBottom: 16,
	},
	formGroupWithTopMargin: {
		marginTop: 16,
	},
	formRow: {
		display: 'grid',
		gap: 16,
		gridTemplateColumns: 'repeat(2, 1fr)',
		marginBottom: 16,
	},
	formSection: {
		borderTop: `1px solid ${colors.border.main}`,
		marginTop: 24,
		paddingTop: 24,
	},
	input: {
		border: `1px solid ${colors.border.main}`,
		borderRadius: 4,
		fontSize: 14,
		padding: '8px 12px',
	},
	label: {
		color: colors.text.main,
		fontSize: 14,
		fontWeight: 'bold',
		marginBottom: 8,
	},
	priceSummary: {
		background: colors.background.main,
		border: `1px solid ${colors.border.main}`,
		borderRadius: 8,
		display: 'flex',
		flexDirection: 'column',
		fontSize: 14,
		gap: 8,
		marginTop: 16,
		padding: 16,
	},
	required: {
		color: colors.danger.main,
	},
	sectionTitle: {
		color: colors.text.main,
		fontSize: 16,
		fontWeight: 'bold',
		marginBottom: 16,
	},
	select: {
		border: `1px solid ${colors.border.main}`,
		borderRadius: 4,
		fontSize: 14,
		padding: '8px 12px',
	},
	successSection: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		marginTop: 24,
		textAlign: 'center',
	},
	successTitle: {
		color: colors.success.main,
		fontSize: 18,
		fontWeight: 'bold',
		marginTop: 0,
	},
	successMessage: {
		color: colors.text.main,
		fontSize: 14,
		marginTop: 8,
		textAlign: 'center',
	},
	textarea: {
		border: `1px solid ${colors.border.main}`,
		borderRadius: 4,
		fontSize: 14,
		minHeight: 80,
		padding: '8px 12px',
		resize: 'vertical',
	},
	title: {
		color: colors.text.main,
		fontSize: 20,
		fontWeight: 'bold',
		marginTop: 0,
	},
});
